import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { KeycloakService } from '@inoventoryapps/keycloak-angular';
import { BehaviorSubject, tap } from 'rxjs';
import { GeoMap } from '../models/geo.model';
import { KeycloakUserInfo } from '../models/keycloak.model';
import { UserDetails } from '../models/user.model';
import { CdnService } from './cdn.service';
import { LocalStorageService } from './local-storage.service';

@Injectable({
    providedIn: 'root'
})
export class GlobalService {
    public toolbarSearchSubject = new BehaviorSubject<string>('');
    public toolbarSearch$ = this.toolbarSearchSubject.asObservable();
    public GEO_LOCATION: GeoMap[];

    constructor(
        private http: HttpClient,
        private ls: LocalStorageService,
        private keycloakService: KeycloakService,
        private cdn: CdnService
    ) {}

    async getUserInfo() {
        const userInfoResponse: any = await this.keycloakService.loadUserInfo();
        const userInfo: KeycloakUserInfo = userInfoResponse;
        return userInfo;
    }

    getUserDetails() {
        return this.ls.get<UserDetails>('userDetails')!;
    }

    loadGeoMap() {
        return this.cdn.getGeoMap().pipe(tap((response) => (this.GEO_LOCATION = response)));
    }

    getGeoLocation(
        data: Partial<{ blockId: string; districtId: string; stateId: string }>,
        role: 'block' | 'district' | 'state' | 'national'
    ) {
        let find: GeoMap | undefined;
        const geo: Partial<{ blockId: string; districtId: string; stateId: string }> = {
            stateId: undefined,
            districtId: undefined,
            blockId: undefined
        };

        if (role !== 'national') {
            find = this.GEO_LOCATION.find((val) => val[`${role}_id`] === data[`${role}Id`]);
            geo.stateId = find?.state_id.split('-')[1];
            if (role === 'district' || role === 'block') geo.districtId = find?.district_id?.split('-')[1];
            if (role === 'block') geo.blockId = find?.block_id?.split('-')[1];
        }
        return geo;
    }

    async download1(name: string, id: string) {
        const fileName = decodeURIComponent(name);
        const mimeType = 'application/octet-stream';

        const url = `/api/vault/pg/v1/${id}/${fileName}`;

        try {
            const blob = await this.http.get(url, { responseType: 'blob' }).toPromise();
            if (!blob) throw new Error('No file received');

            const downloadUrl = URL.createObjectURL(new Blob([blob], { type: mimeType }));
            const a = document.createElement('a');
            a.href = downloadUrl;
            a.download = fileName;
            a.click();
            URL.revokeObjectURL(downloadUrl);
        } catch (err) {
            console.error('Download failed:', err);
        }
    }
}
